{
  "hero": {
    "heading": "A Printable Planner <br/> for Every Teacher <br/> in the District.",
    "description": "A printable planner with your district dates already filled in.",
    "checks": [
      "No-school days, already shaded.",
      "Printable PDF via Shareable Link.",
      "12 months. 52 weeks. Done for you."
    ],
    "secondary_cta": "",
    "planner_image_alt": "Planner — monthly and weekly pages"
  },
  "benefits": {
    "eyebrow": "What's inside",
    "heading": "Every date. Already there.",
    "items": [
      {
        "eyebrow": "Already filled in",
        "title": "Every district calendar date.",
        "body": "Holidays, PD days, early dismissals, the first day, the last day. Add the dates once, everyone gets them."
      },
      {
        "eyebrow": "Print at the office or home",
        "title": "To everyone in 5 minutes.",
        "body": "PDF that prints beautifully on any printer. Print the whole year or just next week. One link to share."
      },
      {
        "eyebrow": "Yours forever",
        "title": "Update any time.",
        "body": "If a district date changes, update it once, and it updates everywhere, for everyone. Weather Days included."
      }
    ]
  },
  "faq": {
    "eyebrow": "Common questions",
    "heading": "Anything else?",
    "items": [
      {
        "question": "What size is the printable?",
        "answer": "The printable planner is designed to fit on standard 8.5×11 paper, making it easy to print from home or work."
      },
      {
        "question": "Can teachers print this from home?",
        "answer": "Yes. You'll receive a shareable link to the printable planner: a 12-month printable and a 52-week printable. Share this link with everyone in the district. Print from the office or right from home."
      },
      {
        "question": "Can teachers access the planner online?",
        "answer": "Yes, teachers can access an interactive version of the planner online anytime. Quickly scroll through weeks and months."
      },
      {
        "question": "What if the district dates change?",
        "answer": "While most district dates stay the same, sometimes the calendar needs to change. If your district has a change, simply update the planner dates, and teachers can print it again. This is especially helpful for Weather Make-up Days. Update once and it's accurate everywhere."
      },
      {
        "question": "Can schools use this?",
        "answer": "Yes. You can share the link with all schools in your district. You manage the dates and everyone benefits. \n\n If schools in your district want a school-specific calendar, we can help with that too. Email schools@agendahero.com for more info."
      },
      {
        "question": "Do you have educator discounts?",
        "answer": "Yes, the pricing for the printable planner license is significantly discounted for schools. We know education budgets are tight. One license gives you unlimited use. \n\n If you're interested in more offerings for school, email schools@agendahero.com."
      },
      {
        "question": "Why did you create Agenda Hero?",
        "answer": "We're parents who were spending way too much time figuring out who had to be where and when. We wanted to solve this problem for ourselves, and everyone else, too. \n\n We have a simple philosophy: Why should every parent, teacher, or staff have to duplicate manual, tedious calendar efforts when one person can create the schedule, and everyone can benefit?"
      }
    ]
  },
  "final_cta": {
    "heading": "More time for joy.",
    "description": "12 Months. 52 Weeks. Done for You.",
    "price_line": "One license. Unlimited prints."
  },
  "footer": { "help": "Help", "terms": "Terms", "privacy": "Privacy" },
  "checkout": {
    "label": "One for Every Teacher · $250 Flat",
    "cta_aria": "Get your planner"
  }
}
